module.exports = __webpack_public_path__ + "img/lepus.2b83e054.png";